module.exports = __webpack_public_path__ + "static/media/send.aa7a2217.svg";